import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Flex, Text, Avatar, Icon, Box } from "@chakra-ui/react";
import { RedirectIcon } from "../Icons";
import { GetDiffDates } from "../../Utils";
import Roles from "../../resources/Roles";

const MessagesItem = ({ alert }) => {
  const history = useHistory();
  const location = useLocation();

  const toProgramDetail = () => {
    const { program } = alert;
    const redirectTo = `/programs/view/${program?._id}/${program?.type}`;
    if (location.pathname === redirectTo) {
      window.location.reload();
      return;
    }
    history.push(redirectTo);
  };

  return (
    <Box w="100%" position="relative" py={1}>
      <Flex
        bg="white"
        border="1px solid #D5D5D5"
        direction="column"
        w="-webkit-fill-available"
        p={2}
        borderRadius={12}
        onClick={toProgramDetail}
      >
        <Flex justify={"space-between"}>
          <Flex gap={2}>
            <Avatar
              borderRadius={5}
              size="sm"
              bg="green.100"
              color="white"
              name={`${alert?.user?.name} ${alert?.user?.lastName}`}
            />
            <Box fontSize={"md"} color={"black"}>
              <Text noOfLines={1} fontWeight={700}>
                {`${alert?.user?.name} ${alert?.user?.lastName} `}
                <Text as="span" color="gray.400" fontSize="xs">
                  ({Roles.find((r) => r.key === alert.role)?.name || alert.role}
                  )
                </Text>
              </Text>
              <Text noOfLines={1}>Mensaje: {`${alert?.message}`}</Text>
            </Box>
          </Flex>
          <Icon as={RedirectIcon} size="md" color={"#9E9E9E"} />
        </Flex>
        {/* --- */}

        <Flex justify="space-between" pl={10} mb={4}>
          <Flex direction="column" color="#9E9E9E" fontSize="xs">
            {alert?.type !== "SYSTEM" && (
              <>
                <Text
                  noOfLines={1}
                >{`Beneficio: ${alert?.program?.programName}`}</Text>
                <Text noOfLines={1}>
                  {`Socio: ${alert?.program?.partner?.name || "NO APLICA"}`}
                </Text>
              </>
            )}
          </Flex>
          <Text color="#9E9E9E" fontSize="xs" noOfLines={1} mt="auto">
            {GetDiffDates(alert?.createdAt)}
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default MessagesItem;
